export default {
  init() {
      $(document).on('click','.dropdown-menu a', function(){
          $('.dropdown .dropdown-toggle').text($(this).text());
      });

      if(window.location.hash.length > 0 && window.location.hash.indexOf('#') !== -1){
          var $form = window.location.hash;
          if( $form ){
              $('.nav-link[href="'+$form+'"]').click();
              $('html, body').animate({
                  scrollTop: $($form).parent().offset().top-140,
              }, 600);
          }
      }
  },
  finalize() {


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateContacts.js